<div class="row">
  <div class="col text-center">
    <h3 mat-dialog-title>
      <span style="color:limegreen;">{{data.title}}</span>
      </h3>
    </div>
</div>
<div mat-dialog-content class="text-info">
  <p>{{data.message}}</p>
</div>
<div class="row">
  <div mat-dialog-actions class="col text-center">
    <button mat-raised-button  style="background-color: red;color: white;min-width: 20%; border: none;" class="mr-3" (click)="onYesClick()">Ok</button>
    <button  mat-raised-button style="background-color: grey;color: white;min-width: 20%; border: none;" (click)="onNoClick()">Cancel</button>
  </div>
</div>
